import {IArrayWizardState} from "../../../types/ui/wizard/array";

export const initialArrayState: IArrayWizardState = {
};
